import { FunctionComponent } from 'react';

import CardBodyText from 'components/CardBodyText';

import { COPY } from './constants';

const OpenBankingSatNoteFormInitialNotice: FunctionComponent = () => (
  <>
    <CardBodyText>{COPY.line1}</CardBodyText>
    <CardBodyText>{COPY.line2}</CardBodyText>
  </>
);

export default OpenBankingSatNoteFormInitialNotice;
